import {
  LoadingListEntityProfile,
  PaginationList,
  ProfilePublication,
} from "Admin/Components";
import { getProfilePublication } from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { Empty } from "antd";
import { useEffect, useState } from "react";
import styles from "./Publications.module.scss";
const Publications = () => {
  const [data, setData] = useState({
    data: [],
    isLoading: true,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfilePublication(
      pagination.page - 1,
      pagination.rowsPerPage,
      (res) => {
        handleAPIResponse(res, () => {
          setData({
            data: res.data.publications,
            isLoading: false,
          });
          if (res.data.total) {
            setPagination({
              ...pagination,
              totalRows: res.data.total,
            });
          }
        });
      }
    );
  }, [pagination.page, pagination.rowsPerPage]);

  return (
    <div className={styles["publications"]}>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data?.length > 0 ? (
            data?.data?.map((item, index) => {
              return <ProfilePublication publication={item} key={index} />;
            })
          ) : (
            <Empty description="No Publication Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <PaginationList pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default Publications;
